<mat-toolbar>
  <button mat-icon-button class="example-icon" aria-label="Example icon-button with menu icon">
    <mat-icon>home</mat-icon>
  </button>
  <span i18n>My App</span>
  <span i18n class="example-spacer"></span>
  
  <button i18n mat-button (click) = "selectBackground()">Add Background</button>
  
  <button i18n mat-button [matMenuTriggerFor]="menu">Direction</button>
  <mat-menu #menu="matMenu">
      <button i18n mat-menu-item (click) = "selectTreeType(3)">Left to Right</button>
      <button i18n mat-menu-item (click) = "selectTreeType(1)">Top to Bottom</button>
  </mat-menu>
  <button i18n mat-button (click) = "change_size()">
    Settings
  </button>
  <button i18n mat-button (click) = "generate()">
    Generate
  </button>
</mat-toolbar>
<mat-card class="setting">
<mat-card-header>
  <mat-card-title>Setting</mat-card-title>
</mat-card-header>
<mat-card-content>
  <p i18n  >Paper Type:  &nbsp; <span>{{p_type}}</span> </p>
  <p i18n  >Male: &nbsp; <canvas id='m_color' width="20" height="20" [ngStyle]="{'background-color': m_Color}"></canvas> &nbsp;{{m_Color}}</p>
  <p i18n  >Male Background: &nbsp; <canvas id='m_color' width="20" height="20" [ngStyle]="{'background-color': m_b_Color}"></canvas> &nbsp;{{m_b_Color}}</p>
  <p i18n  >Female:   &nbsp; <canvas id='m_color' width="20" height="20" [ngStyle]="{'background-color': w_Color}"></canvas> &nbsp; {{w_Color}}</p>
  <p i18n  >Female Background:   &nbsp; <canvas id='m_color' width="20" height="20" [ngStyle]="{'background-color': w_b_Color}"></canvas> &nbsp; {{w_b_Color}}</p>
  <p i18n  >Border Color:   &nbsp; <canvas id='m_color' width="20" height="20" [ngStyle]="{'background-color': b_Color}"></canvas> &nbsp; {{b_Color}}</p>
  <p i18n  >Border Width:  &nbsp; {{b_Width}}</p>
  <p i18n  >Background Opacity:  &nbsp; {{back_Opacity}}</p>
  <p i18n  >Node Opacity:  &nbsp; {{node_Opacity}}</p>
  <p i18n  >Max Generation:  &nbsp; {{max_generation}}</p>
  <p i18n  >Corner Round:  &nbsp; {{cornerRound}} </p>
  <p i18n  >Empty Node:  &nbsp; {{empty_node}} </p>
  <p i18n  >Name Text align:  &nbsp; {{name_text_align}} </p>
  <p i18n  >Other Text align:  &nbsp; {{text_align}} </p>
  <p i18n  >Birth Visibility:  &nbsp; {{birthSetting}} </p>
  <p i18n  >Marriage Visibility:  &nbsp; {{marriageSetting}} </p>
  <p i18n  >Death Visibility:  &nbsp; {{deathSetting}} </p>
  <p i18n  >Children Visibility:  &nbsp; {{children_setting}} </p>
  <p i18n  >Flag Visibility:  &nbsp; {{flag_setting}} </p>
  <p i18n  >Avatar Visibility:  &nbsp; {{profile_setting}} </p>
  <p i18n  >Global Padding:  &nbsp; {{global_padding}}% </p>
  <p i18n  >Warning Visibility:  &nbsp; {{warning_setting}}</p>
</mat-card-content>
</mat-card>
<svg></svg>